<template>
    <nav :class="reactiveClass">
        <div class="desktop-nav-item" v-for="item in menu" :key="item.id">
            <a :href="item.normalizedhref">
                {{ item.translated?.name }}
            </a>
        </div>
    </nav>
</template>
<script>
import { defineComponent, unref } from 'vue';
import { useAppStore } from '@stores/App';

export default defineComponent({
    computed: {
        reactiveClass() {
            const app = useAppStore();
            return [unref(app.getBreakpoints().active()), 'desktop-nav'];
        },
    },
    async mounted() {
        const app = useAppStore();
        this.menu = app.getMainNavigation();
    },
    data() {
        return {
            menu: [],
        };
    },
});
</script>
<style lang="scss" scoped>
.desktop-nav {
    display: none;
}

.lg {
    &.desktop-nav {
        display: flex;
        padding: 0;
        width: 100%;
        position: relative;
        list-style: none;
        justify-content: center;
        align-items: center;
        max-width: var(--container-max-width);
        gap: 1rem;
        margin: 32px auto 0;
    }
}

.desktop-nav-item {
    font-size: 14px;

    a {
        font-size: 14px;
        font-family: Optima, serif;
    }
}
</style>
